import { create } from "zustand";

type SubscriptionCache = Record<string, boolean | null>;

interface SubscriptionState {
  cache: SubscriptionCache;
  getSubscription: (clientId: string, eventId: string) => Promise<boolean | null>;
}

export const useSubscriptionStore = create<SubscriptionState>((set: any, get: any) => ({
  cache: {},

  getSubscription: async (clientId: string, eventId: string) => {
    const existing = get().cache[eventId];
    if (existing !== undefined) {
      return existing;
    }

    const res = await fetch("/.netlify/functions/check-event-subscription", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        clientId,
        eventId,
      }),
    });

    if (res.ok) {
      const json = await res.json();
      if (json) {
        set((state: any) => ({ cache: { ...state.cache, [eventId]: json.subscribed } }));
        return json.subscribed;
      }
    } else {
      console.error(await res.json())
    }
    
    return null;
  },

  subscribeEvent: async (clientId: string, eventId: string, subscription: PushSubscriptionJSON) => {
    const res = await fetch("/.netlify/functions/subscribe-event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        clientId,
        eventId,
        subscription,
      }),
    });

    if (res.ok) {
      const json = await res.json();
      if (json) {
        set((state: any) => ({ cache: { ...state.cache, [eventId]: json.subscribed } }));
        return json.subscribed;
      }
    } else {
      console.error(await res.json())
    }
    
    return null;
  },

  unsubscribeEvent: async (clientId: string, eventId: string) => {
    const res =  await fetch("/.netlify/functions/unsubscribe-event", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clientId, eventId }),
    });

    if (res.ok) {
      const json = await res.json();
      if (json) {
        set((state: any) => ({ cache: { ...state.cache, [eventId]: json.subscribed } }));
        return json.subscribed;
      }
    } else {
      console.error(await res.json())
    }
    
    return null;
  },


}));
